import { useQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import { sortBy } from "lodash";

import { DIRECTORY_LIST, PROJECT_LIST } from "../../../graphql/queries/ProjectQueries";
import { ProjectsSection } from "./ProjectsSection";
import { FoldersSection } from "./FoldersSection";
import { Folder } from "./FoldersSection/FoldersList";
import { Project } from "../../../gql/graphql";
import { WithQueryLoader } from "../../shared/WithQueryLoader";

import styles from "./ProjectsView.module.scss";

export const ProjectsView = () => {
  // TODO: move this logic to router
  const { data: directoryData, loading: directoryLoading, error: directoryError } = useQuery(DIRECTORY_LIST);
  const { data: projectData, loading: projectLoading, error: projectError } = useQuery(PROJECT_LIST);

  const [selectedFolder, setSelectedFolder] = useState<Folder | undefined>();

  useEffect(() => {
    if (directoryData?.directoryList) {
      const folders = directoryData.directoryList as Folder[];
      const defaultItem = folders.find((item) => item.default);
      defaultItem && setSelectedFolder(defaultItem);
    }
  }, [directoryData?.directoryList]);

  const folders = useMemo(() => {
    return directoryData?.directoryList as Folder[];
  }, [directoryData?.directoryList]);

  const childrenFolders = useMemo(() => {
    return folders?.filter((folder) => folder.parentDirectory?.id);
  }, [folders]);

  const sortedFolders = useMemo(() => {
    return sortBy(folders, "createdAt");
  }, [folders]);

  const groupedFolders = useMemo(() => {
    const parentFolders = sortedFolders?.filter((folder) => !folder.parentDirectory?.id);

    const groupedFolders = parentFolders?.map((folder) => {
      return {
        ...folder,
        children: childrenFolders?.filter((item) => item.parentDirectory?.id === folder.id),
      };
    });
    return groupedFolders;
  }, [sortedFolders]);

  return (
    <WithQueryLoader isLoading={directoryLoading || projectLoading} error={directoryError || projectError}>
      <div className={styles.container}>
        <FoldersSection
          groupedFolders={groupedFolders}
          selectedFolder={selectedFolder}
          setSelectedFolder={setSelectedFolder}
        />
        <ProjectsSection
          projects={projectData?.projectList as Project[]}
          selectedFolder={selectedFolder}
          groupedFolders={groupedFolders}
        />
      </div>
    </WithQueryLoader>
  );
};
